import { Text } from "tamagui";
import type BusinessModuleModel from "../BusinessModuleModel";

export const BusinessModuleIcon: React.FC<{
  // biome-ignore lint/suspicious/noExplicitAny: Because
  businessModule: BusinessModuleModel<any, any>;
  size?: number;
}> = ({ businessModule, size = 24 }) => {
  if (businessModule.data.emoji) {
    return (
      <Text lineHeight={size} fontSize={size}>
        {businessModule.data.emoji}
      </Text>
    );
  }

  return businessModule.renderIcon(size);
};
